import { render, staticRenderFns } from "./designSettings.vue?vue&type=template&id=453662cb"
import script from "./designSettings.vue?vue&type=script&lang=js"
export * from "./designSettings.vue?vue&type=script&lang=js"
import style0 from "./designSettings.vue?vue&type=style&index=0&id=453662cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports